import {
  storageLocalRmItem,
  storageLocalGetItem,
  storageLocalSetItem
} from './ssohandy-storage.mjs';

import {
  enumSessBlock,
  enumSessIsActive,
  enumSessAccessToken,
  enumSessRefreshToken,
  enumSessTimeStarted,
  enumSessExpiresIn
} from './ssohandy-enum.mjs';

import {
  reqTokenGrantRefreshPOST
} from './ssohandy-req.mjs';

const sessState = {};
const msMin4 = 240000;

const sessGet = () => ({
  [enumSessIsActive]: Boolean( /true/.test( storageLocalGetItem( enumSessIsActive ) ) ),
  [enumSessExpiresIn]: Number( storageLocalGetItem( enumSessExpiresIn ) ),
  [enumSessBlock]: JSON.parse( storageLocalGetItem( enumSessBlock ) || '{}' ),
  [enumSessTimeStarted]: Number( storageLocalGetItem( enumSessTimeStarted ) ),
  [enumSessAccessToken]: storageLocalGetItem( enumSessAccessToken ),
  [enumSessRefreshToken]: storageLocalGetItem( enumSessRefreshToken )
});

const sessSet = opts => {
  const sess = Object.assign({
    [enumSessIsActive]: Boolean( opts[enumSessExpiresIn]),
    [enumSessTimeStarted]: Date.now()
  }, opts );

  storageLocalSetItem( enumSessBlock, JSON.stringify( sess[enumSessBlock]) );
  storageLocalSetItem( enumSessIsActive, String( sess[enumSessIsActive]) );
  storageLocalSetItem( enumSessExpiresIn, String( sess[enumSessExpiresIn]) );
  storageLocalSetItem( enumSessTimeStarted, String( sess[enumSessTimeStarted]) );
  storageLocalSetItem( enumSessRefreshToken, String( sess[enumSessRefreshToken]) );
  storageLocalSetItem( enumSessAccessToken, String( sess[enumSessAccessToken]) );

  return sess;
};

const sessClear = () => {
  if ( sessState.timeout )
    clearTimeout( sessState.timeout );

  storageLocalRmItem( enumSessIsActive );
  storageLocalRmItem( enumSessExpiresIn );
  storageLocalRmItem( enumSessBlock );
  storageLocalRmItem( enumSessTimeStarted );
  storageLocalRmItem( enumSessRefreshToken );
  storageLocalRmItem( enumSessAccessToken );

  return {};
};

const sessRefresh = async ( sess, oauthDetails, fn, msRefreshBefore = msMin4 ) => {
  const sessExpiresIn = sess[enumSessExpiresIn];
  const sessExpires = sess[enumSessTimeStarted] + sessExpiresIn;

  if ( sessExpires - msRefreshBefore < Date.now()
      || typeof sessExpiresIn !== 'number'
      || typeof sessExpires !== 'number' ) {
    const payload = await reqTokenGrantRefreshPOST(
      oauthDetails, sess[enumSessRefreshToken]);

    if ( /2\d\d/.test( payload.status ) ) {
      sess = sessSet({
        [enumSessBlock]: sess[enumSessBlock],
        [enumSessExpiresIn]: payload.json.expires_in,
        [enumSessRefreshToken]: payload.json.refresh_token,
        [enumSessAccessToken]: payload.json.access_token
      });

      if ( typeof fn === 'function' )
        fn( null, sess );
    } else {
      if ( typeof fn === 'function' )
        fn( payload );
      else
        throw new Error( 'session failed' );        

      sessClear();
    }
  }

  if ( sessState.timeout )
    clearTimeout( sessState.timeout );

  if ( sess[enumSessExpiresIn] < msRefreshBefore )
    throw new Error( 'session expires too soon, or refresh interval is too long' );

  sessState.timeout = setTimeout(
    () => sessRefresh( sessGet(), oauthDetails, fn, msRefreshBefore ),
    sess[enumSessExpiresIn] - msRefreshBefore );

  return sess;
};

// returns a 'sess' object or empty {} object
const sessResume = async ( oauthDetails, fn ) => {
  const refreshToken = storageLocalGetItem( enumSessRefreshToken );

  if ( !refreshToken )
    return sessClear();

  return sessRefresh( sessGet(), oauthDetails, fn );
};

const sessResumeTry = async ( oauthDetails, fn ) => {
  try {
    return sessResume( oauthDetails, fn );
  } catch ( e ) { return sessClear(); }
};

export {
  sessState,
  sessRefresh,
  sessResumeTry,
  sessSet,
  sessGet,
  sessClear
};


